import { render, staticRenderFns } from "./InvitationsList.vue?vue&type=template&id=1176c496&"
import script from "./InvitationsList.vue?vue&type=script&lang=ts&"
export * from "./InvitationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports